import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'proposals-campaigns',
imports: [CommonModule],
  templateUrl: './proposals-campaigns.component.html',
  styleUrl: './proposals-campaigns.component.scss'
})
export class ProposalsCampaignsComponent implements OnInit {
  @Input() campaigns: any[] = [];
  isCollapsed: boolean = true;
constructor() {
  }
  ngOnInit(): void {   
  }
  toggleCardBody(): void {
    this.isCollapsed = !this.isCollapsed;
  }
}
